import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import SingleRecipientType from 'owa-service/lib/contract/SingleRecipientType';

interface NameAndEmailForSender {
    name?: string;
    emailAddress?: string;
}

export const getNameAndEmailForSender = (
    sender: SingleRecipientType,
    displaySelf?: boolean
): NameAndEmailForSender => {
    let name: string;
    let emailAddress: string;

    if (displaySelf) {
        const sessionSettings = getUserConfiguration().SessionSettings;
        name = sessionSettings.UserDisplayName;
        emailAddress = sessionSettings.UserEmailAddress;
    } else if (sender && sender.Mailbox) {
        name = sender.Mailbox.Name;
        emailAddress = sender.Mailbox.EmailAddress;
    }

    return {
        name,
        emailAddress,
    };
};
